import { GetEvents422ResponseBody } from "./http/GetEvents.js";

export class BackendUnreachable extends Error {
  constructor(public override cause: any) {
    super("Backend unreachable");
  }
}

export class InvalidFetchAthenaEventsFilters extends Error {
  constructor(
    public filters: object,
    public responseBody: GetEvents422ResponseBody,
  ) {
    super("Invalid filters supplied to fetchAthenaEvents");
  }
}
